import { useMemo, useState } from "react";

export default function ProductForm({
  initial,
  onSubmit,
  submitText = "Yadda saxla",
  saving = false,
}) {
  const init = useMemo(
    () => ({
      price: initial?.price ?? "",

      nameAz: initial?.nameAz ?? "",
      nameEn: initial?.nameEn ?? "",
      nameRu: initial?.nameRu ?? "",

      descAz: initial?.descAz ?? "",
      descEn: initial?.descEn ?? "",
      descRu: initial?.descRu ?? "",

      specs: (initial?.specs || []).map((s) => ({
        id: s.id ?? 0,
        keyAz: s.keyAz ?? "",
        keyEn: s.keyEn ?? "",
        keyRu: s.keyRu ?? "",
        valueAz: s.valueAz ?? "",
        valueEn: s.valueEn ?? "",
        valueRu: s.valueRu ?? "",
      })),

      imageFile: null,
    }),
    [initial],
  );

  const [form, setForm] = useState(init);

  const change = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const changeSpec = (idx, k, v) => {
    setForm((p) => {
      const next = p.specs.slice();
      next[idx] = { ...next[idx], [k]: v };
      return { ...p, specs: next };
    });
  };

  const addSpec = () => {
    setForm((p) => ({
      ...p,
      specs: [
        ...p.specs,
        {
          id: 0,
          keyAz: "",
          keyEn: "",
          keyRu: "",
          valueAz: "",
          valueEn: "",
          valueRu: "",
        },
      ],
    }));
  };

  const removeSpec = (idx) => {
    setForm((p) => ({
      ...p,
      specs: p.specs.filter((_, i) => i !== idx),
    }));
  };

  const submit = (e) => {
    e.preventDefault();

    if (!form.nameAz.trim()) {
      alert("NameAz mütləqdir.");
      return;
    }

    // backend-ə formData göndərəcəyik
    const fd = new FormData();

    fd.append("price", form.price ?? "");

    fd.append("nameAz", form.nameAz ?? "");
    fd.append("nameEn", form.nameEn ?? "");
    fd.append("nameRu", form.nameRu ?? "");

    fd.append("descAz", form.descAz ?? "");
    fd.append("descEn", form.descEn ?? "");
    fd.append("descRu", form.descRu ?? "");

    // ✅ specs JSON (sortOrder YOX)
    fd.append("specsJson", JSON.stringify(form.specs || []));

    if (form.imageFile) fd.append("imageFile", form.imageFile);

    onSubmit(fd);
  };

  return (
    <form onSubmit={submit}>
      <div className="card">
        <div className="cardBody">
          <div className="grid3">
            <div>
              <div className="label">Qiymət</div>
              <input
                className="input"
                value={form.price}
                onChange={(e) => change("price", e.target.value)}
                placeholder="120 AZN"
              />
            </div>

            <div>
              <div className="label">Şəkil</div>
              <input
                className="input"
                type="file"
                accept="image/*"
                onChange={(e) =>
                  change("imageFile", e.target.files?.[0] || null)
                }
              />
            </div>

            <div />
          </div>

          <div style={{ height: 12 }} />

          <div className="grid3">
            <div>
              <div className="label">Ad AZ *</div>
              <input
                className="input"
                value={form.nameAz}
                onChange={(e) => change("nameAz", e.target.value)}
              />
            </div>
            <div>
              <div className="label">Ad EN</div>
              <input
                className="input"
                value={form.nameEn}
                onChange={(e) => change("nameEn", e.target.value)}
              />
            </div>
            <div>
              <div className="label">Ad RU</div>
              <input
                className="input"
                value={form.nameRu}
                onChange={(e) => change("nameRu", e.target.value)}
              />
            </div>
          </div>

          <div style={{ height: 12 }} />

          <div className="grid3">
            <div>
              <div className="label">Məhsul haqqında AZ</div>
              <textarea
                className="input"
                rows="5"
                value={form.descAz}
                onChange={(e) => change("descAz", e.target.value)}
              />
            </div>
            <div>
              <div className="label">Məhsul haqqında EN</div>
              <textarea
                className="input"
                rows="5"
                value={form.descEn}
                onChange={(e) => change("descEn", e.target.value)}
              />
            </div>
            <div>
              <div className="label">Məhsul haqqında RU</div>
              <textarea
                className="input"
                rows="5"
                value={form.descRu}
                onChange={(e) => change("descRu", e.target.value)}
              />
            </div>
          </div>

          <div style={{ height: 14 }} />

          {/* SPECS */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
            }}
          >
            <div style={{ fontWeight: 900 }}>Xüsusiyyətləri</div>
            <button type="button" className="btn btnPrimary" onClick={addSpec}>
              Əlavə et(xüsusiyyət)
            </button>
          </div>

          <div style={{ height: 10 }} />

          {(form.specs || []).map((s, idx) => (
            <div key={idx} className="card" style={{ marginBottom: 10 }}>
              <div className="cardBody">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                  }}
                >
                  <div style={{ fontWeight: 800 }}></div>
                  <button
                    type="button"
                    className="btn btnDanger"
                    onClick={() => removeSpec(idx)}
                  >
                    Sil
                  </button>
                </div>

                <div style={{ height: 10 }} />

                <div className="grid3">
                  <div>
                    <div className="label">Açar söz AZ *</div>
                    <input
                      className="input"
                      value={s.keyAz}
                      onChange={(e) => changeSpec(idx, "keyAz", e.target.value)}
                    />
                  </div>
                  <div>
                    <div className="label">Açar söz EN</div>
                    <input
                      className="input"
                      value={s.keyEn}
                      onChange={(e) => changeSpec(idx, "keyEn", e.target.value)}
                    />
                  </div>
                  <div>
                    <div className="label">Açar söz RU</div>
                    <input
                      className="input"
                      value={s.keyRu}
                      onChange={(e) => changeSpec(idx, "keyRu", e.target.value)}
                    />
                  </div>
                </div>

                <div style={{ height: 10 }} />

                <div className="grid3">
                  <div>
                    <div className="label">Məzmun AZ *</div>
                    <input
                      className="input"
                      value={s.valueAz}
                      onChange={(e) =>
                        changeSpec(idx, "valueAz", e.target.value)
                      }
                    />
                  </div>
                  <div>
                    <div className="label">Məzmun EN</div>
                    <input
                      className="input"
                      value={s.valueEn}
                      onChange={(e) =>
                        changeSpec(idx, "valueEn", e.target.value)
                      }
                    />
                  </div>

                  <div>
                    <div className="label">Məzmun RU</div>
                    <input
                      className="input"
                      value={s.valueRu}
                      onChange={(e) =>
                        changeSpec(idx, "valueRu", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 12,
            }}
          >
            <button className="btn btnPrimary" disabled={saving}>
              {saving ? "Saving..." : submitText}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
